/**
 * Rocksoft.Sync.DeviceTaskManagement
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaskType = {
    None: 'None',
    Wipe: 'Wipe',
    OsUpdate: 'OsUpdate',
    ApplicationSync: 'ApplicationSync',
    AppLockSync: 'AppLockSync',
    AirplaySync: 'AirplaySync',
    ApplicationConfigurationsSync: 'ApplicationConfigurationsSync',
    ConfigurationSync: 'ConfigurationSync',
    DeviceNameSync: 'DeviceNameSync',
    NotificationSync: 'NotificationSync',
    RestrictionsSync: 'RestrictionsSync',
    WifiSync: 'WifiSync',
} as const;
export type TaskType = typeof TaskType[keyof typeof TaskType];

